import * as StaticActions from "../actions/StaticActions";
import {connect} from "react-redux";
import React from "react";
import {Button, Loader} from "semantic-ui-react";
import {Editor, EditorState, ContentState, convertFromRaw} from 'draft-js';

class StaticText extends React.Component {

    state = {
        editorState: null,
    };

    componentDidMount() {
        this.props.loadStaticTexts();

        if (this.props.texts && !this.state.editorState){
            let {texts, label} = this.props;
            this.loadText(texts, label);
        }
    }

    componentWillReceiveProps(props) {
        let {texts, label} = props;
        this.loadText(texts, label);
    }

    loadText(texts, label) {
        if (texts && label) {
            let texts2 = Object.values(texts).filter(text => text.id === label);
            if (texts2.length === 1) {
                let text = texts2[0];
                this.setState({
                    editorState: text.blocks && EditorState.createWithContent(convertFromRaw(text.blocks)),
                });
            }
        }
    }

    render() {
        return this.props.fetching ? <Loader active size="tiny"/> : <div>
            {this.state.editorState && <Editor editorState={this.state.editorState} readOnly={true} />}
            {/*{this.props.texts[this.props.label] && this.props.texts[this.props.label].text}*/}
        </div>
    }
}

export default connect(state => ({
    fetching: state.staticTexts.fetching,
    texts: state.staticTexts.items,
}), dispatch => ({
    loadStaticTexts: () => dispatch(StaticActions.fetchStaticTextsIfNecessary()),
}))(StaticText)


// WEBPACK FOOTER //
// ./src/components/StaticText.js